<!-- eslint-disable vue/valid-v-model -->
<template>
  <div
    v-if="modal"
    class="overlay"
  >
    <div
      v-model="modal"
      class="wrapper"
    >
      <div class="body-text">
        {{ bodyMessage }}
      </div>
      <hr />
      <div class="button-wrapper">
        <Button
          :title="'No'"
          :classType="'primary grey'"
          :eventFunction="closeModalhandler"
        />
        <ReplaceMedia
          :closeModalhandler="closeModalhandler"
          :getMediaList="getMediaList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  SET_OVERFLOW,
} from '../store/actions/common';
import Button from './common/Button.vue';
import ReplaceMedia from './common/ReplaceMedia.vue';

export default {
  name: 'NotificationReplaceModal',
  components: {
    ReplaceMedia,
    Button,
  },
  props: {
    modal: Boolean,
    title: {
      type: String,
      default: '',
    },
    bodyMessage: {
      type: String,
      default: '',
    },
    onAccept: {
      type: Function,
      default: () => {},
      required: false,
    },
    changeReplaceHandler: {
      type: Function,
      default: () => {},
      required: false,
    },
    getMediaList: {
      type: Function,
      default: () => {},
      required: false,
    },
  },
  methods: {
    closeModal() {
      this.$emit('input', false);
      this.$store.dispatch(SET_OVERFLOW, false);
    },
    accept() {
      this.onAccept();
      this.closeModal();
    },
    closeModalhandler() {
      this.closeModal();
      this.changeReplaceHandler();
    },
    acceptHandler() {
      this.accept();
    },
  },
};
</script>

<style scoped>
  .wrapper {
    background-color: #383b40;
    border-radius: 4px;
    display: block;
    left: 50%;
    max-width: 100%;
    outline: none;
    overflow-wrap: break-word;
    position: absolute;
    text-decoration: none;
    top: 40%;
    transform: translate(-50%, -50%);
    width: 500px;
  }

  .headline,
  .edit-wrapper {
    color: #fff;
  }

  .edit-wrapper {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.375rem;
    padding: 13px 16px;
  }

  .headline {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.0125em;
    line-height: 2rem;
    margin: 0;
    padding: 13px 16px;
    word-break: break-all;
  }

  hr {
    border: solid;
    border-color: rgba(0, 0, 0, 0.12);
    border-width: thin 0 0;
    display: block;
    flex: 1 1 0;
    height: 0;
    max-height: 0;
    max-width: 100%;
    transition: inherit;
  }

  .button-wrapper {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    padding: 8px 16px;
  }

  .button-wrapper button:first-child {
    margin-right: 15px;
  }

  .lighten-2 {
    color: #fff !important;
    font-size: 16px;
  }

  .body-text {
    color: #fff !important;
    font-size: 16px;
    padding: 40px 55px 50px;
    text-align: center;
  }

  .overlay {
    background-color: rgba(0, 0, 0, 0.5);
    bottom: 0;
    height: 100%;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    z-index: 10;
  }
</style>
